export default import.meta.ROLLUP_FILE_URL_U2dHQy6kVNUCyKgOH4xjIA